import { Box, Flex } from '@chakra-ui/react';
import { useStore } from '@data/other/withStore';
import BEImage from '@molecules/BEImage';
import { observer } from 'mobx-react';
import PromoCode from '../PromoCode';
import { Routes as AppRoutes } from '@view/routes';
import { useCallback } from 'react';
import { useNavigate } from '@view/hooks/useNavigate';

const Landing = () => {
  const { property, components } = useStore();
  const { accommodations, addons } = property;
  const navigate = useNavigate();

  const onClickSearch = useCallback(
    async (checkin?: Date, checkout?: Date, code?: string) => {
      components.promoCode.set({ checkin, checkout, code });
      await accommodations.search(
        components.promoCode.value.checkin,
        components.promoCode.value.checkout
      );
      navigate(AppRoutes.Accommodations);
    },
    [
      accommodations,
      addons,
      property.model,
      navigate,
      components.promoCode.value.checkin,
      components.promoCode.value.checkout,
    ]
  );

  return (
    <Flex
      w="100%"
      h="calc(100vh - 150px)"
      minH="500px"
      maxH="700px"
      bgColor="#DDD"
      position="relative"
      alignItems="center"
      justifyContent="center"
    >
      <Box w="100%" h="100%" position="absolute" top="0" left="0">
        <BEImage
          cursor="default"
          width="100%"
          height="100%"
          fit="cover"
          src={property?.model?.coverImage?.src}
        />
      </Box>
      <PromoCode layout="vertical" onClickSearch={onClickSearch} />
    </Flex>
  );
};

export default observer(Landing);
